// extracted by mini-css-extract-plugin
export var boxItems = "_9l-1";
export var boxItemsLg = "_9l-2";
export var button = "_9l-7";
export var buttonHoverless = "_9l-9";
export var buttonLg = "_9l-8";
export var filterGroupBox = "_9l-0";
export var icon = "_9l-3";
export var iconSecondary = "_9l-6";
export var iconWrapper = "_9l-4";
export var iconWrapperLg = "_9l-5";
export var truncatedLabel = "_9l-a";